import { Fragment } from 'react';

import type { ProfilePageSettings } from 'src/components/Profile/CreateResume/reducer';

const featureStore: Record<string, boolean> = {};

export const hydrateFeatures = ({
  features = '',
}: ProfilePageSettings = {}) => {
  features.split(',').forEach((feature) => {
    featureStore[feature] = true;
  });
};

type FeatureName =
  | 'profile-insights'
  | 'profile-suggestions'
  | 'people-search'
  | 'profile-avatar';

export const isFeatureActive = (featureName: FeatureName): boolean =>
  Boolean(featureStore[featureName]);

export const FeatureFlag = ({
  children,
  name,
}: {
  children: React.ReactNode;
  name: FeatureName;
}) => (isFeatureActive(name) ? <Fragment>{children}</Fragment> : null);
